define('lq/events/actions/login',[
    'jquery',
    'lq',
    'lq/events/actions/eventAction'
], function ($, lq, EventAction) {
    'use strict';

    function Login(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Login, EventAction);

    Login.typeName = 'Login';

    Login.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Login.prototype.loginParameters = {};
    Login.prototype.mfaPollingTimer = {};

    var loginCallback = function (self, result, returnUrl, continuation, showBody, loginParameters) {
        if (result.status === 'Success') {
            self.piping.parameters.systems.setValue("CurrentUser", result.userId);
            returnUrl = returnUrl || lq.getTenantUrl('');

            if (self.eventIsEnabled('userLoggedIn'))
                self.piping.dispatcher.refreshCsrfToken(function () {
                    self.triggerEvent('userLoggedIn', continuation, returnUrl);
                });
            else
                window.location = returnUrl;
        }
        else {
            if (showBody) $('body').show();

            if (result.mfaId) loginParameters.mfaId = result.mfaId;

            if (result.status === 'LoginFromLocalStorageFailed')
                return;
            else if (result.status === 'InvalidCaptcha')
                self.handleError('invalidCaptcha', 'The captcha is incorrect.', continuation);
            else if (result.status === 'InvalidCredentials')
                self.handleError('invalidCredentials', 'The username or password provided is incorrect.', continuation);
            else if (result.status === 'UserLoginNotAllowed')
                self.handleError('userLoginNotAllowed', 'The user is not allowed to log in.', continuation, result.userId);
            else if (result.status === 'AccountLocked')
                self.handleError('accountLocked', 'Your account has been locked out because of too many invalid login attempts.', continuation);
            else if (result.status === 'MfaChallenged') {
                self.startPollingMfaStatus(loginParameters);
                self.handleError('mfaChallenged', 'MFA is necessary.', continuation);
            }
            else if (result.status === 'MfaExpired') {
                self.stopPollingMfaStatus();
                self.handleError('mfaExpired', 'MFA is expired.', continuation);
            }
            else if (result.status === 'MfaCodeInvalid')
                self.handleError('mfaCodeInvalid', 'The MFA code is incorrect.', continuation);
            else
                alert('Unable to login.');
        }
        if (result.eventsToExecute) {
            _.each(result.eventsToExecute, function (eventName) {
                self.piping.eventing.publish(eventName, self.eventSource, null, continuation, null);
            });
        }
    }

    Login.prototype.getUsername = function () {
        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.usernameField)
            .getValue();
    };

    Login.prototype.getPassword = function () {
        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.passwordField)
            .getValue();
    };

    Login.prototype.getMfaCode = function () {
        if (!this.eventData.mfaCodeField) return null;

        return this.piping.dropFactory
            .findDropByViewModelKey(this.eventData.mfaCodeField)
            .getValue();
    };

    Login.prototype.getCaptcha = function () {
        if (!this.eventData.captchaField) return null;

        var captchaDrop = this.piping.dropFactory
            .findDropByName(this.eventData.captchaField);

        if (!captchaDrop.data.captchaInputField) return null;

        return this.piping.dropFactory
            .findDropByName(captchaDrop.data.captchaInputField)
            .getValue();
    };

    Login.prototype.execute = function (continuation) {
        this.executeLogin(continuation, null, null);
    }

    Login.prototype.executeLogin = function (continuation, mfaConfirmed, loginParameters) {
        var mfaCode = mfaConfirmed ? null : this.getMfaCode();
        var useStoredCredentials = mfaConfirmed || mfaCode;
        loginParameters = loginParameters || this.getLoginParameters(useStoredCredentials);
        var returnUrl = this.piping.queryString.getValueOf('ReturnUrl');

        //deliberately not calling continuation(), because it makes no sense to continue event execution after a login/redirect
        var self = this;
        this.piping.dispatcher.dispatch(
            'LicquidAction/LoginCommand', {
            actionId: this.piping.actionId,
            commandId: this.eventData.command,
            captcha: loginParameters.captcha,
            appId: this.piping.queryString.getValueOf('AppId'),
            parameters: {
                username: loginParameters.username,
                password: loginParameters.password,
                mfaId: loginParameters.mfaId,
                mfaCode: mfaCode,
                mfaConfirmed: mfaConfirmed
            }
        }, function (result) {
            loginCallback(self, result, returnUrl, continuation, false, loginParameters);
        });
    };

    Login.prototype.getLoginParameters = function (useStoredCredentials) {
        var command = this.eventData.command;
        var storedLoginParameters = useStoredCredentials
            ? this.loginParameters[command]
            : null;

        if (storedLoginParameters) return storedLoginParameters;

        return {
            username: this.getUsername(),
            password: this.getPassword(),
            captcha: this.getCaptcha(),
            mfaId: null
        };
    };

    Login.prototype.handleError = function (eventName, defaultMessage, continuation, eventArg) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation, eventArg);
        } else {
            alert(defaultMessage);
            continuation();
        }
    };

    Login.prototype.stopPollingMfaStatus = function () {
        var self = this;
        var command = self.eventData.command;

        var timer = self.mfaPollingTimer[command];
        if (timer) {
            clearTimeout(timer);
            self.mfaPollingTimer[command] = undefined;
        }
    }

    Login.prototype.startPollingMfaStatus = function (loginParameters) {
        var self = this;
        var command = self.eventData.command;

        self.stopPollingMfaStatus();

        self.loginParameters[command] = loginParameters;

        var pollMfaStatus = function () {
            self.piping.dispatcher.backgroundDispatch(
                'Mfa/Status',
                {
                    mfaId: loginParameters.mfaId
                },
                function (result) {
                    if (self.loginParameters[command] !== loginParameters ||
                        !self.mfaPollingTimer[command]) return;

                    if (result.expired) {
                        self.stopPollingMfaStatus();
                        self.handleError('mfaExpired', 'MFA is expired.', function () { });
                        return;
                    }

                    if (result.confirmed) {
                        self.stopPollingMfaStatus();
                        self.executeLogin(null, true, loginParameters);
                        return;
                    }

                    self.startPollingMfaStatus(loginParameters);
                });
        };

        self.mfaPollingTimer[command] = setTimeout(pollMfaStatus, 1000);
    }

    return Login;
});

